import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";


@Component({
    selector: 'im-import-object-component',
    templateUrl: 'im-import-object.component.html',
    standalone: false
})
export class ImImportObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {


    /**
     * On Object Change.
     */
    onObjectChanged() {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}